<div class="auth-container">
  <div class="auth-card">
    <!-- Back Link -->
    <a routerLink="/login" class="back-link">
      <ion-icon name="arrow-back-outline"></ion-icon>
      {{ 'BACK_TO_LOGIN' | translate }}
    </a>

    <!-- Logo & Header -->
    <div class="auth-header">
      <div class="logo-container">
        <img src="assets/logo/bee.png" alt="BizzWeaver" class="auth-logo" />
      </div>
      <h1 class="auth-title">{{ 'FORGOT_PASSWORD_TITLE' | translate }}</h1>
      <p class="auth-subtitle">{{ 'FORGOT_PASSWORD_SUBTITLE' | translate }}</p>
    </div>

    <!-- Success State -->
    @if (isSubmitted) {
      <div class="success-state">
        <div class="success-icon">
          <ion-icon name="checkmark-circle-outline"></ion-icon>
        </div>
        <h2 class="success-title">{{ 'CHECK_YOUR_EMAIL' | translate }}</h2>
        <p class="success-message">{{ 'PASSWORD_RESET_SENT' | translate }}</p>
        <p class="success-email">{{ email }}</p>
        <div class="success-actions">
          <button class="secondary-button" (click)="resetForm()">
            {{ 'TRY_DIFFERENT_EMAIL' | translate }}
          </button>
          <a routerLink="/login" class="primary-link">
            {{ 'BACK_TO_LOGIN' | translate }}
          </a>
        </div>
      </div>
    }

    <!-- Form State -->
    @if (!isSubmitted) {
      <!-- Error Message -->
      @if (errorMessage) {
        <div class="error-banner">
          <ion-icon name="alert-circle-outline"></ion-icon>
          <span>{{ errorMessage | translate }}</span>
        </div>
      }
      <!-- Forgot Password Form -->
      <form (ngSubmit)="onSubmit()" class="auth-form" novalidate>
        <!-- Email Field -->
        <div class="form-group">
          <label for="email" class="form-label">{{ 'EMAIL' | translate }}</label>
          <div class="input-wrapper" [class.invalid]="!isEmailValid() && email.length > 0">
            <ion-icon name="mail-outline" class="input-icon"></ion-icon>
            <input
              type="email"
              id="email"
              [(ngModel)]="email"
              name="email"
              class="form-input"
              [placeholder]="'EMAIL_PLACEHOLDER' | translate"
              autocomplete="email"
              required
              />
            </div>
            @if (!isEmailValid() && email.length > 0) {
              <span class="error-text">
                {{ 'INVALID_EMAIL' | translate }}
              </span>
            }
          </div>
          <!-- Submit Button -->
          <button
            type="submit"
            class="submit-button"
            [disabled]="isLoading"
            >
            @if (isLoading) {
              <ion-spinner name="crescent"></ion-spinner>
            }
            @if (!isLoading) {
              <span>
                {{ 'SEND_RESET_LINK' | translate }}
              </span>
            }
          </button>
        </form>
        <!-- Login Link -->
        <div class="auth-footer">
          <p>
            {{ 'REMEMBER_PASSWORD' | translate }}
            <a routerLink="/login" class="login-link">{{ 'LOGIN_NOW' | translate }}</a>
          </p>
        </div>
      }
    </div>
  </div>
